<template>
  <v-card>
    <v-toolbar dark color="primary">
      <v-btn icon dark @click="closeDialog">
        <v-icon>close</v-icon>
      </v-btn>
      <v-toolbar-title>Listado</v-toolbar-title>
    </v-toolbar>
    <v-flex
      xs12
      sm6
      md4
      lg3
    >
      <v-card>
        <v-card-title><h4>Resumen</h4></v-card-title>
        <v-divider></v-divider>
        <v-list dense>
          <v-list-tile>
            <v-list-tile-content>Total Inmuebles:</v-list-tile-content>
            <v-list-tile-content class="align-end">{{ resumen.length }}</v-list-tile-content>
          </v-list-tile>
          <v-list-tile>
            <v-list-tile-content>Total Inmuebles con Propietarios:</v-list-tile-content>
            <v-list-tile-content class="align-end">{{ inmueblesConUsuarios.length }}</v-list-tile-content>
          </v-list-tile>
          <v-list-tile>
            <v-list-tile-content>Total Inmuebles con Datos en formulario:</v-list-tile-content>
            <v-list-tile-content class="align-end">{{ inmueblesForm.length }}</v-list-tile-content>
          </v-list-tile>
        </v-list>
      </v-card>
    <v-divider></v-divider>
    </v-flex>

    <v-container fluid grid-list-md>
    <v-flex
      v-for="inmueble in inmueblesForm" :key="inmueble.id"
      xs12
      sm6
      md4
      lg3
    >
      <v-card>
        <v-card-title><h4>{{ `${('0000' + inmueble.id).substr(-4, 4)}` }}</h4></v-card-title>
        <v-divider></v-divider>
        <v-list dense>
          <v-list-tile>
            <v-list-tile-content>Total Inmuebles:</v-list-tile-content>
            <v-list-tile-content class="align-end">{{ resumen.length }}</v-list-tile-content>
          </v-list-tile>
          <v-list-tile>
            <v-list-tile-content>Total Inmuebles con Propietarios:</v-list-tile-content>
            <v-list-tile-content class="align-end">{{ inmueblesConUsuarios.length }}</v-list-tile-content>
          </v-list-tile>
          <v-list-tile>
            <v-list-tile-content>Total Inmuebles con Datos en formulario:</v-list-tile-content>
            <v-list-tile-content class="align-end">{{ inmueblesForm.length }}</v-list-tile-content>
          </v-list-tile>
        </v-list>
      </v-card>

    </v-flex>
    </v-container>
    <!-- <pre>{{ listado }}</pre> -->
    <pre>Total Inmuebles: {{ resumen.length }}</pre>
    <pre>Total Inmuebles con Propietarios: {{ inmueblesConUsuarios.length }}</pre>
    <pre>Total Inmuebles con Datos en formulario: {{ inmueblesForm.length }}</pre>
    <pre>{{ inmueblesForm }}</pre>
  </v-card>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
export default {
  props: ["refCat"],
  data() {
    return {

    };
  },

  computed: {
    ...mapGetters(["inmueblesForm", "propietariosForm"]),

    listado() {
      // return this.$store.getters.getPropietariosCatastro(this.$route.params.id)
      return this.$store.getters.getCatastroId(this.refCat);
    },

    resumen() {
      if (!this.listado || !this.listado.inmuebles || !this.listado.catastroUsers) { // || !Array.isArray(this.listado)
        console.log('Listado vacío');
        return [];
      }
      console.log('listado: ', this.listado);
      const inmuebles = Object.entries(this.listado.inmuebles);
      const propietarios = Object.entries(this.listado.catastroUsers);
      let result = [];
      inmuebles.forEach(inmueble => {
        const prop = propietarios.filter(p => p[0] === inmueble[0]).map(i => i[1]);
        result.push([inmueble[0], inmueble[1], prop])
      });
      return result;
    },
    inmueblesConUsuarios() {
      return this.resumen.filter(i => i[2].length > 0);
    }
  },

  methods: {
    ...mapActions(["setCatastroForm", "unSetCatastroForm"]),
    closeDialog() {
      this.$emit("closeDialog");
    }
  }
};
</script>